import { Component, OnInit, Input} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { HttpClient } from '@angular/common/http';
import { ImportFileType } from 'src/app/models/ImportFileType';

@Component({
  selector: 'app-coordpointid-status',
  templateUrl: './coordpointid-status.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class CoordpointidStatusComponent implements OnInit {

  @Input()
  coordPoints:CoordinatePointModel[];

  @Input()
  importAerodromes: boolean = false;

  @Input()
  fileToUpload: File

  @Input()
  modalId: number

  constructor(public bsModalRef: BsModalService,
    public pointsService: PointsService,
    private uiBlock: UiBlockService,
    private endpointService: EndpointsService,
    private modalService: ModalControlService,
    private http: HttpClient) { }

  ngOnInit(): void {
  }

  cancel():void{
    this.bsModalRef.hide();
  }


  public static getListWithDuplicates(coordPoints:CoordinatePointModel[]): CoordinatePointModel[]{
    const toReturn: CoordinatePointModel[] = [];
    const processedIds = new Set<string>();
    for (const coordPoint of coordPoints){
      coordPoint.notupdate = true;
      coordPoint.updated = false;
      toReturn.push(coordPoint);
      if (coordPoint.coordpointid.length > 5){
        coordPoint.invalidId = true;
      }
      if (processedIds.has(coordPoint.coordpointid)){
        continue;
      }
      processedIds.add(coordPoint.coordpointid);
      const duplicates = coordPoints.filter(point => point.coordpointid == coordPoint.coordpointid);
      duplicates.forEach(dup => dup.isDuplicate = true);
      coordPoint.isDuplicate = false;
    }
    return toReturn;
  }
  checkIfvalid(coordPoint: CoordinatePointModel){
    const duplicates = this.coordPoints.filter(point => point.coordpointid == coordPoint.coordpointid);
    duplicates.forEach(dup => dup.isDuplicate = true);
    coordPoint.isDuplicate = false; 
    if (coordPoint.coordpointid.length > 5){
      coordPoint.invalidId = true;
    } else {
      coordPoint.invalidId = false;
    }

  }

  getValidCoordPoints(){
    return this.coordPoints.filter(cp => !cp.invalidId);
  }

  proceedWithImport(){
    this.bsModalRef.hide(this.modalId);
    const validCoordPoints = this.getValidCoordPoints();
    if (!validCoordPoints || validCoordPoints.length == 0){
      this.modalService.showMesssageModal(
        'Error Importing',
        'None of the imported data is valid.'
      );
      return;
    }
    this.coordPoints = validCoordPoints;
    if (this.importAerodromes){
      this.pointsService.importParsedCP(validCoordPoints, this.fileToUpload);
    } else {
      this.pointsService.importParsedCP(validCoordPoints);
    }
  }




}
